import { render, staticRenderFns } from "./GovernorList.vue?vue&type=template&id=745eec6c"
import script from "./GovernorList.vue?vue&type=script&lang=js"
export * from "./GovernorList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports